module.exports = __webpack_public_path__ + "assets/img/two.f51f0da1.png";